import { render, staticRenderFns } from "./frogwares-playtests.vue?vue&type=template&id=2d112a88&scoped=true"
import script from "./frogwares-playtests.vue?vue&type=script&lang=js"
export * from "./frogwares-playtests.vue?vue&type=script&lang=js"
import style0 from "./frogwares-playtests.vue?vue&type=style&index=0&id=2d112a88&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d112a88",
  null
  
)

export default component.exports